import React, { useEffect, useState } from "react";
import {
  Button,
  Image,
  Link,
  makeStyles,
  Text,
} from "@fluentui/react-components";
import { RouteEnum, useRoute } from "../../contextApis/RouteContext";
import { useUserSessionContext } from "../../contextApis/UserSessionContext";

/* global document, window, Office */

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    gap: "24px",
    padding: "24px",
    width: "100%",
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    backgroundColor: "#ffffff",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "24px",
    fontWeight: "600",
  },
  title: {
    lineHeight: "32px",
    fontSize: "28px",
    fontWeight: "600",
    color: "#202b36",
    marginBottom: "16px",
    textAlign: "center",
  },
  subtitle: {
    fontSize: "16px",
    color: "#4a5868",
    maxWidth: "600px",
    lineHeight: "1.5",
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    maxWidth: "320px",
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    marginTop: "auto",
  },
  links: {
    display: "flex",
    gap: "24px",
  },
});

const Home = () => {
  const { navigate } = useRoute();
  const { isLoggedIn } = useUserSessionContext();

  const styles = useStyles();

  const [userDisplayName, setUserDisplayName] = useState<string>("");

  useEffect(() => {
    if (!Office?.context?.mailbox?.userProfile) return;

    setUserDisplayName(Office.context.mailbox.userProfile.displayName);
  }, []);

  if (document.getElementById("tridentmessage")?.style.display === "block") {
    return (
      <div className={styles.container}>
        <Text>
          This add-in requires a newer version of Microsoft Office. Please
          upgrade to continue.
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Image src="tr-48.png" alt="Truckrates AI" />
        <Text size={800}>Truckrates AI</Text>
      </div>

      <div className={styles.content}>
        <Text className={styles.title}>
          Welcome{userDisplayName ? ` ${userDisplayName}` : null} to the
          Truckrates AI Add-In
        </Text>
        <Text className={styles.subtitle}>
          Search and bid on profitable freight lanes directly from your inbox.
          Get real-time rate data to make confident pricing decisions in
          seconds.
        </Text>
      </div>

      {!isLoggedIn ? (
        <>
          <div className={styles.buttons}>
            <Button
              appearance="primary"
              size="large"
              onClick={() => navigate(RouteEnum.SIGN_IN)}
            >
              Log in
            </Button>
            <Button
              appearance="outline"
              size="large"
              onClick={() =>
                window.open(
                  "https://drayage.pro.typeform.com/sign-up?typeform-source=www.truckrates.ai",
                  "_blank noreferrer",
                )
              }
            >
              Sign up for a free account
            </Button>
          </div>

          <Link
            onClick={() =>
              window.open(
                "https://www.truckrates.ai/support",
                "_blank noreferrer",
              )
            }
          >
            Having issues logging in?
          </Link>
        </>
      ) : null}

      <footer className={styles.footer}>
        <Text>©2024 Truckrates AI. All Rights Reserved</Text>
        <div className={styles.links}>
          <Link
            onClick={() =>
              window.open(
                "https://www.truckrates.ai/privacy",
                "_blank noreferrer",
              )
            }
          >
            Privacy Policy
          </Link>
          <Link
            onClick={() =>
              window.open(
                "https://www.truckrates.ai/terms",
                "_blank noreferrer",
              )
            }
          >
            Terms of Service
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Home;
